module.exports = __webpack_public_path__ + "img/2.32cec174.svg";